import React from "react";
import PropTypes from "prop-types";
import HorizontalSlider from "../../../common/HorizontalSlider";
import Item from "./Item";

import styles from "./sidebar.module.scss";

function Sidebar({items, activeItem, onClick}) {
  return (
    <div className={styles.root}>
      <HorizontalSlider
        dots={false}
        arrows={false}
        slidesToShow={2}
        variableWidth
        infinite={false}
        swipeToSlide={true}
        className={styles.slider}
      >
        {items
          .reduce(
            (acc, {children}) => (children ? [...acc, ...children] : acc),
            []
          )
          .map(
            ({singular: name, title: itemTitle, preview, minPrice, path}) => (
              <Item
                key={name}
                title={itemTitle}
                preview={preview}
                minPrice={minPrice}
                path={path}
                selected={name === activeItem}
                onClick={onClick && onClick(name)}
              />
            )
          )}
      </HorizontalSlider>
      <div className={styles.bar}>
        {items.map(({title, children}) => (
          <div className={styles.item} key={title}>
            <div className={styles.title}>{title}</div>
            <div className={styles.barContent}>
              {children.map(
                ({
                  singular: name,
                  title: itemTitle,
                  shortTitle,
                  minPrice,
                  path
                }) => (
                  <div key={name}>
                    <Item
                      categoryTitle={title}
                      title={itemTitle}
                      shortTitle={shortTitle}
                      path={path}
                      minPrice={minPrice}
                      selected={name === activeItem}
                      onClick={onClick && onClick(name)}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      children: PropTypes.array
    })
  ),
  activeItem: PropTypes.string,
  onClick: PropTypes.func
};

export default Sidebar;
